import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export const router = createRouter({ routeTree });

function isStaleChunkError(reason: unknown): boolean {
  const msg = reason instanceof Error ? reason.message : String(reason);
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('the server responded with a MIME type of')
  );
}

// vite-plugin-pwa는 빌드/SSR 평가 단계에서 모듈 그래프를 끌어와 평가하므로
// 모듈 최상위에서 `window` 직접 접근 시 `window is not defined`로 폭발한다.
if (typeof window !== 'undefined') {
  // stale chunk error는 silent reload 대신 DeploymentBanner로 통일.
  // vite:preloadError와 동일 채널로 dispatch — 사용자가 새로고침 버튼을 눌러야 reload.
  window.addEventListener('unhandledrejection', (event) => {
    if (isStaleChunkError(event.reason)) {
      event.preventDefault();
      window.dispatchEvent(new Event('vite:preloadError'));
    }
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
